<template>
    <card bg="bg-dark text-white" title="Muestras Solicitadas">
        <div class="card mt-4">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <div v-if="details.length > 0" class="row" style="min-height: 40px; width: 100%">
                            <div class="col-md-8">
                                <b-form-checkbox v-if="!request.allEstimatedDeliveryDateOenology" id="checkbox-global-date"
                                    class="mt-2 ml-2" name="check-button" switch
                                    title="Asignar la misma fecha para todos los items" @change="ShowGlobalDate()">Fecha
                                    Estimada Global</b-form-checkbox>
                               
                            </div>
                            <div class="col-md-4">
                                <span style="float: right">
                                    <button v-if="request.allEstimatedDeliveryDateOenology &&
                                        !request.allDeliveryDateOenology
                                        " id="save-all-edo" class="btn btn-success ml-2" @click="SaveAllDeliveryGlobalDate">
                                        <i class="fas fa-save"></i>
                                        Registrar Entrega Global
                                    </button>
                                    <button v-if="!request.allEstimatedDeliveryDateOenology" id="save-all-edo"
                                        class="btn btn-success ml-2" @click="SaveAllEstimatedDate">
                                        <i class="fas fa-save"></i>
                                        Guardar Fechas Estimadas
                                    </button>
                                    <button v-if="!request.allEstimatedDeliveryDateOenology" class="btn btn-danger ml-2"
                                        @click="reject">
                                        <i class="fas fa-ban"></i>
                                        Invalidar {{ buttonText }}
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="global-date-box" v-if="!request.allEstimatedDeliveryDateOenology" class="row mt-2 p-4" style="display: none">
                    <div class="col-md-12 table-bordered">
                        <div class="row p-4">
                            <div class="col-md-6">
                                <label class="edo-all">Fecha de Entrega Estimada Enología
                                    (Para todos los
                                    items)</label>
                                <input id="edo-all" v-model="ddoAll" class="form-control edo-all" type="date" />
                            </div>
                            <div class="col-md-4">
                                <button id="set-edo-to-all" style="margin-top: 32px !important;" class="btn btn-primary" @click="SetDateToAllItems">
                                    <i class="fas fa-save"></i>
                                    Asignar Fecha Estimada Global
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <card v-if="detailNew.length > 0" title="Nuevo Producto">
            <div class="table-responsive">
                <div v-for="item in detailNew" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <div class="card-header">
							<div class="row">
								<div class="col-md-8">
									<h5 class="card-title d-inline"><b>VINO: {{ item.variety }}
                                        {{ item.valley }} {{ item.quality }}</b></h5>
								</div>
								<div class="col-md-4 text-right">
									<div :id="'options-butons-' + item.id">
                                        <b-form-checkbox v-if="item.sampleDetailStage === 2 && !item.estimatedDeliveryDateOenology" class="mt-2" name="check-button" switch
                                            @change="SampleList(item.id)">Seleccionar</b-form-checkbox>
                                        <button v-if="!item.deliveryDateOenology" id="save-ddo" :style="item.estimatedDeliveryDateOenology == null
                                                ? 'display: none;'
                                                : ''
                                            " class="btn btn-success" title="Registra la entrega real de lo solicitado"
                                            @click="SaveDeliveryDate(item.id)">
                                            <i class="fas fa-save"></i>
                                            Registrar Entrega
                                        </button>
									</div>
                                   
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
                                </div>
                                <div v-if="item.wineSample" class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered table-dates-input">
                                        <tr >
                                            <th style="width: 50%">Fecha Entrega Estimada Enología</th>
                                            <th v-if="item.deliveryDateOenology" style="width: 50%">Fecha Entrega Enología</th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <input style="max-width: 400px;" v-if="!item.estimatedDeliveryDateOenology" :id="'edo-' + item.id"
                                                                :data-detailid="item.id" class="form-control edo-item"
                                                                type="date" />
                                                            <span v-if="item.estimatedDeliveryDateOenology"
                                                                class="badge badge-warning" style="font-size: 20px">{{
                                                                    item.estimatedDeliveryDateOenologyString
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td v-if="item.deliveryDateOenology">
                                                <span :data-detailid="item.id" class="ddo-item" style="display: none"></span>
                                                <span class="badge badge-success"
                                                    style="font-size: 20px">{{ item.deliveryDateOenologyString }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode" style="width: 20%">
                                                    Mezcla Comercial
                                                </th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">
                                                        {{ item.comercialMix }} - {{ item.comercialMixCode }}
                                                    </span>
                                                </td>
                                                <td>
													<span class="badge badge-info p-2">{{ item.variety }}</span> 
																										<span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
													<span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table
                                        class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Muestra Enológica</th>
                                            <th>Con Degustación</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <i v-if="item.wineSample" class="fa fa-check text-success"></i>
                                                <i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span v-if="item.sampleDetailStage !== 2" class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                                <div v-if="item.sampleDetailStage === 2" class="row">
                                                    <div class="col-md-10">
                                                        <input class="form-control" type="number" min="1900" v-model="item.finalHarvest" />
                                                    </div>
                                                    <div class="col-md-2 text-right">
                                                        <button @click="saveFinalHarvest(item.id, item.finalHarvest)" class="btn btn-sm btn-success">
                                                            <i class="fas fa-save"></i>
                                                        </button>
                                                    </div>
                                               </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="ChangeIconCollapse(item.id)">Ver más
                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="3">
                                                    Componentes Asociados
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Capsula</th>
                                                <td>{{ item.capsuleCode }}</td>
                                                <td>{{ item.capsuleName }}</td>
                                            </tr>
                                            <tr>
                                                <th>Tapa</th>
                                                <td>{{ item.cappingCode }}</td>
                                                <td>{{ item.cappingName }} </td>                                          
                                            </tr>
                                            <tr>
                                                <th>Caja</th>
                                                <td>{{ item.boxCode }}</td>
                                                <td>{{ item.boxName }}</td>
                                            </tr>
                                            <tr>
                                                <th>Botella</th>
                                                <td>{{ item.bottleCode }}</td>
                                                <td>{{ item.bottleName }}</td>
                                            </tr>
                                            <tr>
                                                <th>Etiqueta</th>
                                                <td>{{ item.labelCode }}</td>                                              
                                                <td>{{ item.labelName }} </td>
                                            </tr>
                                            <tr>
                                                <th>Contraetiqueta</th>
                                                <td>{{ item.backLabelCode }}</td>                                              
                                                <td>{{ item.backLabelName }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                    <table class="table table-striped table-bordered">
                                        <tr class="thead-dark">
                                            <th style="width: 25%">Otro Semielaborado</th>
                                        </tr>
                                        <tr>
                                            <td :style="item.sampleDetailStage === 2 ? 'width: 70%' : 'width: 75%'">
                                                <div class="d-flex align-items-center">
                                                    <div style="flex: 1;">
                                                        <span v-if="item.otherSemiElaborateCode">{{ item.otherSemiElaborateCode }} - {{ item.otherSemiElaborateName }}</span>
                                                        <span v-else class="badge badge-info">No Establecido</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style="width: 5%" v-if="item.sampleDetailStage === 2">
                                                <button @click="showOtherSemiElaborate(item.id, item.comercialMixCode, item.sku)" class="btn btn-sm btn-primary">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div v-if="item.isNewComposition == true" class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="2">
                                                    Nueva Composición
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Variedad</th>
                                                <th>Porcentaje</th>
                                            </tr>
                                            <tr v-for="composition in item.compositionDetails" :key="composition.id">
                                                <td v-if="item.id ===
                                                    composition.requestCommercialSampleDetailID
                                                    ">
                                                    {{ composition.variety }}
                                                </td>
                                                <td v-if="item.id ===
                                                    composition.requestCommercialSampleDetailID
                                                    ">
                                                    {{ composition.percent }}%
                                                </td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div v-if="item.reasonOenologySended" class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Motivo de envío a Enología</th>
                                                <td>{{ item.reasonOenologySended }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="3">Observaciones Adicionales</th>
                                            </tr>
                                            <tr v-if="item.requestDetailObservations">
                                                <th style="width: 18%">Fecha</th>
                                                <th style="width: 12%">Usuario</th>
                                                <th style="width: 70%">Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="observation in item.requestDetailObservations" :key="observation.id">
                                                <td>{{ observation.createdAtString }}</td>
                                                <td>{{ observation.email }}</td>
                                                <td>{{ observation.observation }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="row">
                                                        <div class="col-10">
                                                            <input class="form-control" :id="'observation-input-' + item.id" type="text" />
                                                        </div>
                                                        <div class="col-2">
                                                            <button class="btn btn-success float-right" @click="addObservation(item.id)">
                                                                <i class="fa fa-save"></i>
                                                                <span class="ml-2">Registrar Observación</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        <card v-if="detailFinish.length > 0" title="Producto Terminado">
            <div class="table-responsive">
                <div v-for="item in detailFinish" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <div class="card-header">
							<div class="row">
								<div class="col-md-8">
									<h5 class="card-title d-inline"><b>SKU: {{ item.sku }}</b></h5>
								</div>
								<div class="col-md-4 text-right">
									<div :id="'options-butons-' + item.id">
                                        <b-form-checkbox v-if="item.sampleDetailStage === 2 && !item.estimatedDeliveryDateOenology" class="mt-2" name="check-button" switch
                                            @change="SampleList(item.id)">Seleccionar</b-form-checkbox>
                                        <button v-if="!item.deliveryDateOenology" id="save-ddo" :style="item.estimatedDeliveryDateOenology == null
                                                    ? 'display: none;'
                                                    : ''
                                                " class="btn btn-success" title="Registra la entrega real de lo solicitado"
                                                @click="SaveDeliveryDate(item.id)">
                                                <i class="fas fa-save"></i>
                                                Registrar Entrega
                                        </button>
									</div>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
                                </div>
                                <div v-if="item.wineSample" class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered table-dates-input">
                                        <tr>
                                            <th style="width: 50%">Fecha Entrega Estimada Enología</th>
                                            <th v-if="item.deliveryDateOenology" style="width: 50%">Fecha Entrega Enología</th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <input style="max-width: 400px;" v-if="!item.estimatedDeliveryDateOenology" :id="'edo-' + item.id"
                                                                :data-detailid="item.id" class="form-control edo-item"
                                                                type="date" />
                                                            <span v-if="item.estimatedDeliveryDateOenology"
                                                                class="badge badge-warning" style="font-size: 20px">{{
                                                                    item.estimatedDeliveryDateOenologyString
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td v-if="item.deliveryDateOenology">
                                                <span :data-detailid="item.id" class="ddo-item" style="display: none"></span>
                                                <span class="badge badge-success"
                                                    style="font-size: 20px">{{ item.deliveryDateOenologyString }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Sku</th>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode">Mezcla Comercial</th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.sku }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">
                                                        {{ item.comercialMix }} -   {{ item.comercialMixCode }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span> 
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Sku (Para Despacho)</th>
                                            <th>Muestra Enológica</th>
                                            <th>Con Degustación</th>
                                            <th>Requiere Trasvasije</th>
                                            <th>Vino No Real</th>
                                            <th>No Maquetar</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalSku }}</span>
                                            </td>
                                            <td>
                                                <i v-if="item.wineSample" class="fa fa-check text-success"></i>
                                                <i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
                                                <i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.notRealWine" class="fa fa-check text-success"></i>
                                                <i v-if="!item.notRealWine" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.notLayout" class="fa fa-check text-success"></i>
                                                <i v-if="!item.notLayout" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span v-if="item.sampleDetailStage !== 2" class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                                <div v-if="item.sampleDetailStage === 2" class="row">
                                                    <div class="col-md-10">
                                                        <input class="form-control" type="number" min="1900" v-model="item.finalHarvest" />
                                                    </div>
                                                    <div class="col-md-2 text-right">
                                                        <button @click="saveFinalHarvest(item.id, item.finalHarvest)" class="btn btn-sm btn-success">
                                                            <i class="fas fa-save"></i>
                                                        </button>
                                                    </div>
                                               </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="ChangeIconCollapse(item.id)">Ver más
                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="3">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            Componentes Asociados
                                                        </div>
                                                        <div class="col-md-6 text-right">
                                                              Zona de venta:
                                                            <span class="ml-2">{{ item.saleZone }}</span>
                                                        </div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <th style="width: 8%">Posición</th>
                                            <th style="width: 15%">Código</th>
                                            <th>Componente</th>
                                        </thead>
                                        <tr v-for="lc in item.components" :key="lc.id">
                                             <td>
                                                {{ lc.componentPosition }}
                                            </td>
                                            <td v-if="lc.requestCommercialSampleDetailId === item.id">
                                                {{ lc.c_sku }}
                                            </td>
                                            <td colspan="2" v-if="lc.requestCommercialSampleDetailId === item.id">
                                                {{ lc.d_sku }}
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-bordered">
                                        <tr class="thead-dark">
                                            <th colspan="2">
                                                Semielaborado
                                            </th>
                                        </tr>
                                        <tr>
                                            <td style="width: 22%">{{ item.semiElaborateCode }} </td>
                                            <td>{{ item.semiElaborateName }} </td>
                                        </tr>
                                    </table>
                                    <table v-if="item.otherSemiElaborateCode" class="table table-striped table-bordered">
                                        <tr class="thead-dark">
                                            <th colspan="2">Otro Semielaborado:</th>
                                        </tr>
                                        <tr v-if="item.otherSemiElaborateCode">
                                            <td style="width: 22%">
                                                {{ item.otherSemiElaborateCode }}
                                            </td>
                                            <td style="width: 78%;">
                                                {{ item.otherSemiElaborateName }}
                                            </td>
                                        </tr>
                                        <tr v-else="">
                                            <td colspan="2">
                                                <span class="badge badge-info">No Establecido</span>
                                            </td>
                                        </tr>
                                    </table>                                    
                                </div>
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div v-if="item.reasonOenologySended" class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Motivo de envío a Enología</th>
                                                <td>{{ item.reasonOenologySended }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="3">Observaciones Adicionales</th>
                                            </tr>
                                            <tr v-if="item.requestDetailObservations">
                                                <th style="width: 18%">Fecha</th>
                                                <th style="width: 12%">Usuario</th>
                                                <th style="width: 70%">Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="observation in item.requestDetailObservations" :key="observation.id">
                                                <td>{{ observation.createdAtString }}</td>
                                                <td>{{ observation.email }}</td>
                                                <td>{{ observation.observation }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="row">
                                                        <div class="col-10">
                                                            <input class="form-control" :id="'observation-input-' + item.id" type="text" />
                                                        </div>
                                                        <div class="col-2">
                                                            <button class="btn btn-success float-right" @click="addObservation(item.id)">
                                                                <i class="fa fa-save"></i>
                                                                <span class="ml-2">Registrar Observación</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        <card v-if="detailBottle.length > 0" title="Producto Guarda Botella">
            <div class="table-responsive">
                <div v-for="item in detailBottle" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <div class="card-header">
							<div class="row">
								<div class="col-md-8">
									<h5 class="card-title d-inline"><b>CÓDIGO: {{ item.sku }}</b></h5>
								</div>
								<div class="col-md-4 text-right">
									<div :id="'options-butons-' + item.id">
                                     
									</div>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
								</div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Código</th>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode">Mezcla Comercial</th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.sku }}</span>
                                                </td>
                                                <td><span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">{{ item.comercialMix }} - {{ item.comercialMixCode }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span> 
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Con Degustación</th>
                                            <th>Requiere Trasvasije</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
                                                <i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span v-if="item.sampleDetailStage !== 2" class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                                <div v-if="item.sampleDetailStage === 2" class="row">
                                                    <div class="col-md-10">
                                                        <input class="form-control" type="number" min="1900" v-model="item.finalHarvest" />
                                                    </div>
                                                    <div class="col-md-2 text-right">
                                                        <button @click="saveFinalHarvest(item.id, item.finalHarvest)" class="btn btn-sm btn-success">
                                                            <i class="fas fa-save"></i>
                                                        </button>
                                                    </div>
                                               </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="ChangeIconCollapse(item.id)">Ver más
                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-lg-6 col-md-12 col-sm-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="2">Componentes Asociados</th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr v-if="item.capsuleName">
                                                <th>Capsula</th>
                                                <td>{{ item.capsuleName }} - {{ item.capsuleCode }}</td>
                                            </tr>
                                            <tr v-if="item.cappingName">
                                                <th>Tapa</th>
                                                <td>{{ item.cappingName }} - {{ item.cappingCode }}</td>                                             
                                            </tr>
                                            <tr v-if="item.boxName">
                                                <th>Caja</th>
                                                <td>{{ item.boxName }} - {{ item.boxCode }}</td>                                             
                                            </tr>
                                            <tr v-if="item.bottleName">
                                                <th>Botella</th>
                                                <td>{{ item.bottleName }} - {{ item.bottleCode }}</td>                                               
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="3">Observaciones Adicionales</th>
                                            </tr>
                                            <tr v-if="item.requestDetailObservations">
                                                <th style="width: 18%">Fecha</th>
                                                <th style="width: 12%">Usuario</th>
                                                <th style="width: 70%">Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="observation in item.requestDetailObservations" :key="observation.id">
                                                <td>{{ observation.createdAtString }}</td>
                                                <td>{{ observation.email }}</td>
                                                <td>{{ observation.observation }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="row">
                                                        <div class="col-10">
                                                            <input class="form-control" :id="'observation-input-' + item.id" type="text" />
                                                        </div>
                                                        <div class="col-2">
                                                            <button class="btn btn-success float-right" @click="addObservation(item.id)">
                                                                <i class="fa fa-save"></i>
                                                                <span class="ml-2">Registrar Observación</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        <modal id="otherSemiElaborateModal"  title="Asignar otro Semielaborado">
            <other-semielaborate-modal :othersSemiElaborateList="othersSemiElaborateList" @saveOtherSemilaborate="saveOtherSemilaborate" :sampleId="id" :detailId="detailIdSelected" :commercialMixCode="detailIdSelectedMCCode" :finisehdProductCode="detailIdSelectedPTCode"></other-semielaborate-modal>
        </modal>
    </card>
</template>
<script>
//import toastr from "toastr";
import { Get, Post, Put } from "../../../helper/axios";
import $ from "jquery";

export default {
    props: ["request", "details", "id", "component", "progressDispatch"],
    data() {
        return {
            Put,
            Get,
            Post,
            apiUrl: this.$store.getters.apiUrl,
            detailId: 0,
            listSelectSample: [],
            exist: false,
            updateValid: {},
            rejectionReason: "",
            validDispatch: false,
            ddoAll: "",
            detailIdSelected: 0,
            detailIdSelectedMCCode: '',
            detailIdSelectedPTCode: '',
            othersSemiElaborateList: [],
            othersPtList: []
        };
    },
    methods: {
        reject() {
            this.$swal({
                title: "¿Desea Invalidar " + this.buttonText + "?",
                input: "text",
                text: "Si es así, debe ingresar el motivo de la invalidación",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    if (this.listSelectSample.length == 0) {
                        this.details.forEach((element) => {
                            this.listSelectSample.push(element.id);
                        });
                    }
                    let listValid = [];
                    this.listSelectSample.forEach((item) => {
                        listValid.push({
                            id: item,
                        });
                    });
                    this.updateValid = {
                        action: "Reject",
                        reason: result.value,
                        list: listValid,
                    };
                    this.$store.commit("setLoading", true);
                    this.Put(
                        this.apiUrl + "v1/details/validtodispatch/" + this.id,
                        this.updateValid,
                        () => {
                            this.$store.commit("setLoading", false);
                            //this.$router.push("/");
                            this.listSelectSample = [];
                            this.$swal.fire(
                                "Invalidación!",
                                "La(s) solicitud(es) ha(n) sido invalidada(s) correctamente."
                            );
                            location.reload();
                        }
                    );
                }
            });
            this.updateDispatch = {};
        },
        SampleList(id) {
            for (var i = 0; i < this.listSelectSample.length; i++) {
                if (this.listSelectSample[i] === id) {
                    this.listSelectSample.splice(i, 1);
                    this.exist = true;
                }
            }

            if (this.exist == false) {
                this.listSelectSample.push(id);
            }
            this.exist = false;
        },
        getRequest() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/requestsamples/", (res) => {
                this.requests = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        isValid() {
            let isValid = true;
            if (this.listSelectSample.length > 0) {
                this.listSelectSample.forEach((item) => {
                    let ddo = $("#edo-" + item).val();
                    if (ddo == "") isValid = false;
                });
            } else {
                if (!this.ddoAll) isValid = false;
                else isValid = true;
            }
            return isValid;
        },
        ChangeIconCollapse(item) {
            if ($("#icon" + item).hasClass("fa-angle-down"))
                $("#icon" + item).toggleClass("fa-angle-up");
            else if ($("#icon" + item).hasClass("fa-angle-up"))
                $("#icon" + item).toggleClass("fa-angle-down");
        },
        SaveAllEstimatedDate() {
            let list = [];
            $(".edo-item").each(function (i, obj) {
                if ($(obj).val() !== "" && $(obj).val() != undefined) {
                    list.push({
                        id: $(obj).data("detailid"),
                        estimatedDeliveryDateOenology: $(obj).val(),
                        isDeliveryDate: false,
                    });
                }
            });
            this.$swal({
                title: "¿Desea guardar las Fecha estimadas de entregas desde Enología?",
                text: "Esto no considerará las muestras Invalidadas",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.Put(
                        `${this.apiUrl}v1/details/deliveryDateEnology/`,
                        list,
                        () => {
                            this.$store.commit("setLoading", false);
                            this.listSelectSample = [];
                            window.toastr.success(
                                "Se han registrado las fechas estimadas de entrega desde Enología correctamente."
                            );
                            location.reload();
                        }
                    );
                }
            });
        },
        SetDateToAllItems() {
            let date = $("#edo-all").val();
            $(".edo-item").each(function (i, obj) {
                $(obj).val(date);
            });
        },
        ShowGlobalDate() {
            let value = $("#checkbox-global-date").is(":checked");
            if (value) {
                $("#global-date-box").show();
            } else {
                $("#global-date-box").hide();
                $(".edo-item").each(function (i, obj) {
                    $(obj).val("");
                });
            }
        },
        SaveAllDeliveryGlobalDate() {
            const list = (this.details || [])
                .filter(item => !item.deliveryDateOenology && item.estimatedDeliveryDateOenology)   // solo los que muestran el TD
                .map(item => ({ id: item.id, isDeliveryDate: true }));
            this.DeliveryDate(list, true);
        },
        SaveDeliveryDate(id) {
            let list = [];
            list.push({
                id: id,
                isDeliveryDate: true,
            });
            this.DeliveryDate(list);
        },
        DeliveryDate(list, isGlobal = false) {
            this.$swal({
                title: isGlobal ? "Registrar Entrega Global" : "Registrar entrega",
                text: isGlobal
                    ? "¿Desea registrar la Entrega Global de las muestras enológicas? Se registrará con la fecha actual"
                    : "¿Desea registrar la entrega de las muestra enológica? Se registra con la fecha actual",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.Put(
                        `${this.apiUrl}v1/details/deliveryDateEnology/`,
                        list,
                        () => {
                            this.$store.commit("setLoading", false);
                            this.listSelectSample = [];
                            window.toastr.success(
                                "Se han registrado las fechas estimadas de entrega desde Enología correctamente."
                            );
                            location.reload();
                        }
                    );
                }
            });
        },
        showOtherSemiElaborate(detailId, commercialMixCode, finishedProductCode){
            this.othersSemiElaborateList = []
            this.detailIdSelected = detailId;
            this.detailIdSelectedMCCode = commercialMixCode;
            this.detailIdSelectedPTCode = finishedProductCode 
            this.getSemiElaborateList(commercialMixCode);
            $("#otherSemiElaborateModal").modal("show");
        },
        getSemiElaborateList(commercialMixCode) {
            if (commercialMixCode)
            {
                this.$store.commit("setLoading", true);
                this.semiElaboareList = [];
                let isPt = false;
                let data = "Size=20&IsPt=" + isPt + "&CommercialMixCode="+commercialMixCode + "&NoPaged=true";
                this.Get(this.apiUrl + "v1/MasterItems/GetToSelect?" + data, (res) => {
                    res.data.forEach((element) => {
                        this.othersSemiElaborateList.push({
                            label: element.c_sku + "  " + element.d_sku,
                            code: element.c_sku,
                            brand: element.d_family,
                            quality: element.d_sub_heading,
                        });
                    });
                    this.$store.commit("setLoading", false);
                });
            }
        },
        saveOtherSemilaborate() {
            this.detailIdSelected = 0;
            this.detailIdSelectedMCCode = '';
            this.detailIdSelectedPTCode = '';
            $("#otherSemiElaborateModal").modal("hide");
            this.$emit("saveOtherSemilaborate");
            this.$emit("getDetails");

        },
        saveFinalHarvest(detailId, finalHarvest) {

            let data = {
				detailId: detailId,
				finalHarvest: finalHarvest
			};
            this.Put(`${this.apiUrl}v1/requestsample/${this.id}/details/saveFinalHarvest`, data, () => {
                    this.$store.commit("setLoading", false);
                    this.otherSemiElaborate = {}
                    window.toastr.success('Cosecha Final Actualizada Correctamente.');
                    this.$emit("getDetails");
                }
            );
        },
        downloadFile(id) {
            window.open(`${this.apiUrl}v1/documentfile/${id}`);
        },
        addObservation(detailId) {
			this.$store.commit("setLoading", true);
			let obs = document.getElementById("observation-input-" + detailId);
			let data = {
				requestCommercialSampleDetailId: detailId,
				observation: obs.value
			};
			this.Post(`${this.apiUrl}v1/RequestDetailObservations`, data, () => {
				this.$store.commit("setLoading", false);
				window.toastr.success("Se ha registrado la Observación correctamente.");
                obs.value = '';
                this.$emit("updateObservations");
			});
		},
        showStockModal(type, sku, harvest) {
            this.stock = {}
            this.$store.commit("setLoading", true);
            let data = 'Sku=' + sku + '&Type=' + type
            if (harvest)
                data += '&Harvest=' + harvest
            this.Get(this.apiUrl + "v1/MasterItems/GetStock?" + data, (res) => {
                this.stock = res.data;
                this.$swal({
                    title: "Consulta de Stock",
                    html:   `<table class="table table-sm table-bordered text-left">
                                <tr>
                                    <th style="width: 160px">Tipo</th>
                                    <td>`+this.stock.materialDescription +`</td>
                                </tr>
                                <tr>
                                    <th>Sku</th>
                                    <td>`+this.stock.sku +`</td>
                                </tr>
                                <tr>
                                    <th>Descripción</th>
                                    <td>`+this.stock.skuDescription +`</td>
                                </tr>
                                <tr>
                                    <th>Cosecha (Año)</th>
                                    <td>`+this.stock.harvest +`</td>
                                </tr>
                                <tr>
                                    <th>Stock</th>
                                    <td>`+this.stock.stock +`</td>
                                </tr>
                                <tr>
                                    <th>Actualizado</th>
                                    <td>`+this.stock.updatedStockAtString +`</td>
                                </tr>
                            </table>`,
                    icon: "info",
                    confirmButtonColor: "#3085d6",
                    width: 800
                });
            });
            this.$store.commit("setLoading", false);
        },        
    },
    computed: {
        detailNew: function () {
            return this.details.filter((x) => x.requestTypeId === 1);
        },
        detailFinish: function () {
            return this.details.filter((x) => x.requestTypeId === 2);
        },
        detailBottle: function () {
            return this.details.filter((x) => x.requestTypeId === 3);
        },
        buttonText() {
            if (this.listSelectSample == 0) {
                return "Todo";
            } else {
                return "Selección";
            }
        },
    },
};
</script>
